<template>
    <div class="panel-button">
       <el-collapse-item class='panel-title' title="默认排序" name="1">
         <el-form class="form">
           <template v-for="(order, index) in orders">
             <div class="type-content" :key="index">
               <el-row class="type-filter">
                 <el-col :span="16"><label>字段</label></el-col>
                 <el-col class="type-icon" :span="8">
                   <span class="left-icon el-icon-plus" @click="addOrder(index)"></span>
                   <span class="right-icon el-icon-minus" @click="delOrder(index)"></span>
                 </el-col>
               </el-row>
               <el-row class="input-type">
                 <el-col :span="12">
                   <public-combobox class="type-selece" v-model="order.columnId" :options="columns" :optionsVisable="{key: 'order-panel', order}"></public-combobox>
                 </el-col>
                 <el-col :span="12">
                   <el-select class="type-selece" v-model="order.orderType">
                     <el-option label="升序" value="asc"></el-option>
                     <el-option label="降序" value="desc"></el-option>
                   </el-select>
                 </el-col>
               </el-row>
             </div>
           </template>
         </el-form>
       </el-collapse-item>
   </div>
</template>

<script>
import Order from '@/store/report/order.js'
import publicCombobox from '@/components/public/public-combobox.vue'

export default {
  name: 'OrderPanel',
  inject: ['reportService'],
  props: ['orders'],
  components: {publicCombobox},
  methods: {
    addOrder (index) {
      let order = new Order({columnId: '', orderType: 'asc'})
      //  在当前这行后面插入一个order
      this.orders.splice(index + 1, 0, order)
    },
    delOrder (index) {
      if (this.orders.length > 1) {
        this.orders.splice(index, 1)
      } else {
        this.$message({
          showClose: true,
          message: '至少保留一行',
          type: 'info'
        })
      }
    }
  },
  watch: {
    orders: {
      handler (value) {
        this.$emit('updateOrder', value)
      },
      deep: true
    }
  },
  computed: {
    columns () {
      let columns = this.reportService.report.columns
      return columns.map(m => {
        // 每次下拉框选择完，column中被选择过的会被过滤
        const used = this.orders.map(o => o.columnId).includes(m.id)
        return { ...m, used }
      })
    }
  }
}
</script>

<style lang="scss">
.panel-button {
  .panel-title{
    height: 100%;
    .el-collapse-item__wrap {
       overflow: auto;
       max-height: 480px;
     }
  }
  .el-collapse-item__content {
    padding-bottom: 0;
  }
  .form {
    font-size: 12px;
    .left-icon,.right-icon{
      font-size: 10px;
      font-weight: 700;
    }
     .left-icon{
       color:#76e0bc;
        &:active{
        color:#49c38e;
        }
     }
     .right-icon{
       color:#F64D5E;
        &:active{
        color:#d70909
        }
     }
    .order-content:first-child {
      margin-top: 12px;
    }
    .group{
      margin-right: 0;
     [class*=" el-icon-"], [class^=el-icon-] {
       cursor: pointer;
         margin-right: 0;
     }
    }
    .type-filter{
      label{
        font-size: 12px;
      }
    }
    .type-icon {
      height: 20px;
      padding-top: 4px;
    }
    .order-selece {
      width:100px;
      margin-right: 2px;
    }
    .el-input__inner {
      padding-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/design/order-panel.vue